module.exports = __webpack_public_path__ + "img/usbSwipe3.8f790548.png";